import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectAllTasks, TaskModel } from '@store/slices/task.slice'
import {
  selectRunningTaskIds,
  selectUnresolvedTaskIds,
} from '@store/selectors/task.selectors'
import useTaskPolling from '@shared/hooks/taskPool.hook'
import { EntityId } from '@reduxjs/toolkit'
import { Link } from 'react-router-dom'
import { Overlay, Tooltip } from 'react-bootstrap'

const TaskManager: React.FC = () => {
  const taskUpdateDelayMillisec = 3000
  const tasks: TaskModel[] = useSelector(selectAllTasks) || []
  const runningTaskIds: EntityId[] = useSelector(selectRunningTaskIds) || []
  const unresolvedTaskIds: EntityId[] =
    useSelector(selectUnresolvedTaskIds) || []

  const [runningTasks, setRunningTasks] = useState<TaskModel[]>(
    tasks.filter((task) => runningTaskIds.includes(task.id))
  )
  const [unresolvedTasks, setUnresolvedTasks] = useState<TaskModel[]>(
    tasks.filter((task) => unresolvedTaskIds.includes(task.id))
  )

  const [show, setShow] = useState(false)
  const target = useRef(null)

  useEffect(() => {
    setRunningTasks(tasks.filter((task) => runningTaskIds.includes(task.id)))
  }, [runningTaskIds, tasks])

  useEffect(() => {
    setUnresolvedTasks(
      tasks.filter((task) => unresolvedTaskIds.includes(task.id))
    )
  }, [unresolvedTaskIds, tasks])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (target.current && !(target.current as any).contains(event.target)) {
        setShow(false)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  useTaskPolling(taskUpdateDelayMillisec)

  // Define the popover content
  const myElementToShow = (
    <Tooltip id="overlay-task-list" className={'mt-3'}>
      <ul className={'py-2 px-4 m-0'}>
        {runningTasks.map((task) => (
          <li key={task.id} className={''}>
            {task.relatedLink ? (
              <Link to={task.relatedLink}>{task.title}</Link>
            ) : (
              task.title
            )}
          </li>
        ))}
      </ul>
    </Tooltip>
  )

  return (
    <div className={'text-bg-dark mx-2'}>
      {runningTasks.length > 0 && (
        <span
          style={{ cursor: 'pointer' }}
          className={'text-warning fw-bold'}
          ref={target}
          onClick={(e) => {
            e.stopPropagation()
            setShow(!show)
          }}
        >
          V procesu: {runningTasks.length}
        </span>
      )}
      <Overlay target={target.current} show={show} placement="bottom-start">
        {myElementToShow}
      </Overlay>
    </div>
  )
}

export default TaskManager
